import nudgeStore from '../store/Store';

export default function isNudgedRow(rowKey: string, tableViewId: string): boolean {
    return (
        nudgeStore.nudgedRows.filter(
            nudgedRow => nudgedRow.rowKey === rowKey && nudgedRow.tableViewId === tableViewId
        ).length == 1
    );
}
